<template>
	<div>
		<portal-target name="modal" />
		<portal-target name="payment-failed-modal" />
		<portal-target name="unavailable-event-modal" />
		<portal-target name="magensa-event-details" />
	</div>
</template>

<script>
export default {
	name: 'ModalPortals'
}
</script>
